import React from 'react';
import { QuoteData } from '../../types';
import { UmlLogo } from '../UmlLogo';
interface ProposalFooterProps {
  data: QuoteData;
}
export function ProposalFooter({
  data
}: ProposalFooterProps) {
  return <div className="bg-charcoal-800 border border-white/10 text-white p-8 md:p-12 rounded-2xl text-center mt-8" data-id="element-118">
      <div className="flex justify-center mb-8 text-base" data-id="element-119">
        <UmlLogo variant="dark" data-id="element-120" />
      </div>
      <h3 className="text-xl font-serif font-light mb-1 inline-block border-b border-gold pb-1" data-id="element-121">
        {data.loName}
      </h3>
      <p className="text-gray-400 text-xs tracking-widest uppercase mt-4 mb-6" data-id="element-122">
        President's Club Loan Officer · NMLS# {data.loNmls}
      </p>

      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-gray-300 font-light mb-10" data-id="element-123">
        <a href={`tel:${data.loPhone}`} className="hover:text-gold transition-colors" data-id="element-124">
          {data.loPhone}
        </a>
        <span className="hidden md:inline text-white/20" data-id="element-125">|</span>
        <a href={`mailto:${data.loEmail}`} className="hover:text-gold transition-colors" data-id="element-126">
          {data.loEmail}
        </a>
      </div>

      <p className="text-[9px] text-gray-600 max-w-4xl mx-auto leading-relaxed font-light" data-id="element-127">
        Rates shown are for informational purposes only and are subject to
        change without notice. Your actual rate may vary based on credit score,
        loan amount, property type, and other factors. This is not a commitment
        to lend. Equal Housing Lender.
      </p>
    </div>;
}